import { useRef } from "react";
import { Card, CardContent, Typography } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "./orderSlice";
import { flyToCart, prefersReducedMotion } from "./orders.animations";

const ProductCard = ({ product, index = 0, animate = false }) => {
  const dispatch = useDispatch();

  // How many of this item are already on the pad. The red count in the corner
  // is the only thing on this screen that was not here before: without it, a
  // waiter tapping down a long menu has no way of telling what they have
  // already added except by reading the cart.
  const qty = useSelector(state => {
    const line = state.order.cart.find(i => i.productId === product.id);
    return line ? line.qty : 0;
  });

  // The picture is what flies to the cart, so it is the element we hold on to.
  const imageRef = useRef(null);

  function getInitials(name) {
  if (!name) return ""; // fallback
  const words = name.trim().split(" ");
  if (words.length === 1) {
    return words[0].substring(0, 2).toUpperCase(); // first 2 letters of single word
  } else {
    return (words[0][0] + words[1][0]).toUpperCase(); // first letters of first two words
  }
}

  /**
   * The tap.
   *
   * The item is added FIRST and decorated after, so a ripple that throws for
   * any reason can never cost the shop an order.
   */
  const handleTap = event => {
    dispatch(
      addToCart({
        productId: product.id,
        name: product.name,
        price: product.price,
        imageUrl: product.imageUrl,
      })
    );

    if (prefersReducedMotion()) return;

    // A circle spreading from the finger, cleaned up by its own timer.
    const card = event.currentTarget;
    if (card && card.getBoundingClientRect) {
      const box = card.getBoundingClientRect();
      const size = Math.max(box.width, box.height) * 2.2;
      const ripple = document.createElement("span");
      ripple.className = "dt-ripple";
      ripple.style.width = size + "px";
      ripple.style.height = size + "px";
      ripple.style.left = event.clientX - box.left + "px";
      ripple.style.top = event.clientY - box.top + "px";
      card.appendChild(ripple);
      window.setTimeout(() => {
        if (ripple.parentNode) ripple.parentNode.removeChild(ripple);
      }, 600);
    }

    flyToCart(imageRef.current);
  };

  return (
    <Card
  onClick={handleTap}
  className={"dt-card" + (animate ? " dt-in" : "")}
  style={{
    cursor: "pointer",
    boxShadow: "none",
    border: "1px solid #E9E9E9",
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column", // 👈 IMPORTANT
    // The menu comes in card by card rather than all at once; capped so a
    // long menu's last card is not still waiting half a second later.
    animationDelay: animate ? Math.min(index, 12) * 28 + "ms" : undefined,
    // padding: "12px"
  }}
>
  {/* HOW MANY ARE ON THE PAD — pops in on the first tap, counts up after */}
  <span
    className={"dt-badge" + (qty > 0 ? " dt-badge-show dt-badge-bump" : "")}
    // Re-running the bump needs a fresh element, and the quantity gives one
    // for free: React replaces the node whenever the number changes.
    key={qty}
  >
    {qty > 0 ? qty : ""}
  </span>

  {/* IMAGE CENTERED */}
<div
  ref={imageRef}
  style={{
    width: "100%",
    height: "120px",
    background: "#EBEBEB",
    marginBottom: "5px",
    overflow: "hidden",
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }}
>
  {!product?.imageUrl ? (
    <Typography
      style={{
        fontSize: "58px", // big
        fontWeight: "bold", // bold
        color: "#A9A9A9",
      }}
    >
      {getInitials(product?.name)}
    </Typography>
  ) : (
    <img
      src={product.imageUrl}
      alt=""
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        display: "block",
        margin: 0,
      }}
    />
  )}
</div>




  {/* TEXT LEFT-ALIGNED */}
  <CardContent style={{ padding: "8px 10px" }}>
    <Typography style={{ fontSize: "18px" }}>
      {product.name}
    </Typography>
    <Typography
      style={{
        fontSize: "18px",
        color: "#F64829",
        fontWeight: "bold",
      }}
    >
      ${product.price.toFixed(2)}
    </Typography>
  </CardContent>
</Card>

  );
};

export default ProductCard;
